<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.student.gradeImportList')"></breadcrumb>


        <div class="content">
           <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Filters -->
                <div class="card">
                    <div class="card-header bg-light">
                        <h3 class="card-title">{{$t('form.student.gradeImportList')}}</h3>


                         <button v-show="!incorrectRecords.length" type="submit" class="btn btn-primary float-right"
                            @click="acceptStudentFile">{{$t('form.student.import')}} {{correctRecords.length}} {{$t('form.student.record')}} <span v-show="incorrectRecords.length === 0 && correctRecords.length > 1">(s)</span> </button>

                        <button type="submit" class="btn btn-danger float-right mr-3"
                            @click="rejectStudentFile">{{$t('button.cancel')}}</button>
                    </div>

                    <div class="card-body">
                        <!-- table  -->
                        <div class="card-body table-responsive p-0">
                            <table class="table table-hover">
                                <thead>
                                    <tr class="header">
                                        <th>{{$t('form.student.studentNumber')}}</th>
                                        <th>{{$t('form.course.courseCode')}}</th>
                                        <th>{{$t('form.course.courseTitle')}}</th>
                                        <th>{{$t('form.course.percentage')}}</th>
                                        <th>{{$t('form.course.finalExamDate')}}</th>
                                        <th>{{$t('form.student.grade')}}</th>
                                        <th v-if="localLabel != ''">{{ localLabel }}</th>
                                        <th>{{$t('form.student.descGrade')}}</th>
                                        <th>{{$t('form.course.major')}}</th>
                                        <th>{{$t('form.course.error')}}</th>

                                    </tr>
                                </thead>
                                <tbody >
                                    <tr v-show="incorrectRecords.length"  v-for="(student, index) in incorrectRecords" v-bind:key="index">
                                        <td  v-for="(td, tdindex) in student" v-bind:key="'td'+tdindex">

                                            <span style="color:red">
                                                {{td}}
                                            </span>

                                        </td>
                                    </tr> 
                                    <tr v-for="(grade, index) in correctRecords" v-bind:key="incorrectRecords.length+index">
                                        <td  v-for="(td, tdindex) in grade" v-bind:key="'td'+tdindex">
                                            {{td}}
                                        </td>
                                    </tr>

                                 

                                </tbody>
                            </table>



                            <!-- <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p> -->
                        </div>
                        <!-- table end  -->


                    </div>
                </div>

           </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: ['permissions', 'user', 'dateFormat'],

        data() {
            return {

                correctRecords:[],
                incorrectRecords:[],
                filePath:'',
                localLabel: '',

                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,
                step: 1,


                header: true,
                delimiter: true,
                qualifier: false,
                signature: null,
                updateGrades:false,
            }
        },

        mounted() {
            if (!this.permissions.createImportGrades) {
                return this.$router.push('/');
            }

            this.setLocalVariableData();
        },

        watch: {
            isNormalUser(val) {
                if (val) {
                    this.step = 1;
                } else {
                    this.step = 2;
                }
            }
        },

        computed: {
            isNormalUser() {
                if (!this.user.roles) return true;

                let role = this.user.roles.find(r => r.slug == 'admin');

                if (role || this.user.partner_id == 1) {
                    this.step = 2;
                    return false;
                };

                return true;
            }
        },

        methods: {

            setLocalVariableData(){
                const records = JSON.parse(localStorage.getItem('grades'));
                this.correctRecords = records.correctRecords;
                this.incorrectRecords = records.incorrectRecords;
                this.localLabel = records.localLabel;
                this.filePath = localStorage.getItem('path');
                this.qualifier = localStorage.getItem('qualifier');
                this.signature = localStorage.getItem('signature');
                this.updateGrades = localStorage.getItem('updateGrades');
                this.disableGradeNotifications = localStorage.getItem('disableGradeNotifications');
                
                if(this.correctRecords.length)
                {
                    let msg = '';
                    if( this.correctRecords.length > 1)
                    msg =  this.correctRecords.length + ' records imported successfully.';
                    else
                    msg =  this.correctRecords.length + ' record imported successfully.';
                    window.localStorage.setItem('dataSaved',msg);
                }


            },

            rejectStudentFile() {

                this.isLoading = true;
                axios.post('/api/students/cancel-import' , {path: this.filePath}).
                then(resp=>{
                    this.isLoading = false;
                    this.$router.go(-1);
                })
                .catch(error=>{
                    this.isLoading = false;
                    this.$router.go(-1);
                })

            },

            acceptStudentFile(){
                
                let formData = new FormData();
                let vm = this;
                formData.append("grades", JSON.stringify(this.correctRecords));
                formData.append("path",this.filePath);
                formData.append('qualifier', this.qualifier ? 1 : 0);
                formData.append('signature', this.signature);
                formData.append('updateGrades', this.updateGrades);
                formData.append('disableGradeNotifications', this.disableGradeNotifications);

                this.isLoading = true;
                axios
                    .post("/api/grades/save" , formData)
                    .then(response => {

                        this.isLoading = false;

                        vm.$router.push('/grade-import');

                    })
                    .catch(error =>{
                       this.showAlert(error.response.data.message, "danger");
                        this.isLoading = false;
                    });

                    this.correctRecords = [];
                    this.incorrectRecords = [];
                    localStorage.setItem('grades' ,JSON.stringify([]))
                    window.localStorage.removeItem('qualifier');
                    window.localStorage.removeItem('signature');
            },

            goBack() {
                this.step = 1;
            },

            clear() {
                this.$refs.signaturePad.clearSignature();
            },

            undo() {
                this.$refs.signaturePad.undoSignature();
            },


            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
